
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trains/toplists/[id]",
      function () {
        return require("private-next-pages/trains/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trains/toplists/[id]"])
      });
    }
  